import Events from 'events';
import Constants from './../Constants';

export default class NewsStore extends Events.EventEmitter {

  constructor() {
    super();
    this.open = false;
  }

  openPanel() {
    this.open = true;
    this._emitOpenNews();
  }

  closePanel() {
    this.open = false;
    this._emitCloseNews();
  }

  isOpen() {
    return this.open;
  }

  addOpenListener(callback) {
    this.on(Constants.ACTION_OPEN_NEWS, callback);
  }

  addCloseListener(callback) {
    this.on(Constants.ACTION_CLOSE_NEWS, callback);
  }

  _emitOpenNews() {
    this.emit(Constants.ACTION_OPEN_NEWS);
  }

  _emitCloseNews() {
    this.emit(Constants.ACTION_CLOSE_NEWS);
  }

}
